<template>
  <span v-if="props.text" class="article-card__tag">
    {{ props.text }}
  </span>
</template>

<script setup lang="ts">
const props = defineProps({
  text: {type: String, required: false},
})
</script>
